// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__5OVr0","left":"InfoRow_left__30d07"};